import ApiMethods from "../../ApiManager/ApiMethods";
import {
  upsertClientPackageInCache,
  refreshMembers,
} from "../../app/data/membersStore";

// Single source of truth for "POST client-packages/create, then reflect the result in the
// shared membersStore cache" — used both by PackageAssignFlow.jsx's confirm-step assign (one
// call per member, for multi-vežbač packages) and NewAppointmentFlow.jsx's "12 termina"/
// "8 termina" quick picks (staged locally, then applied here on the New Appointment's own
// Sačuvaj — see handleSave). Keeping this in one place means both call sites always create and
// cache a package row the exact same way.
export async function createClientPackage({
  clientId,
  packageId,
  startDate,
  paymentDate,
  notes,
}) {
  const response = await ApiMethods.post("client-packages/create", {
    client_id: clientId,
    package_id: packageId,
    start_date: startDate,
    payment_date: paymentDate || undefined,
    notes: notes || undefined,
    created_by: localStorage.getItem("id"),
  });
  if (response?.clientPackage) {
    upsertClientPackageInCache(clientId, response.clientPackage);
  } else {
    // No row came back on the response (shouldn't normally happen — the save itself already
    // succeeded, no exception was thrown) — fall back to a background refresh rather than
    // leaving the cache stale until a manual reload.
    refreshMembers();
  }
  return response?.clientPackage;
}
